import React, { useEffect } from 'react'

import { Banner } from './Banner/Banner'
import { CardsList } from './CardsList/CardsList'
import { fetchExams } from './dashboard-actions'
import style from './Dashboard.module.css'
import { selectDashboardStatus, selectIsInFrame } from './selectors'

import { Loader } from 'common/components'
import { useAppDispatch, useAppSelector, useDocumentTitle } from 'common/hooks'
import { resetExam } from 'features/exam'
import { FilterPanel } from 'features/filter'

export const Dashboard = () => {
  const dispatch = useAppDispatch()
  const status = useAppSelector(selectDashboardStatus)
  const isInFrame = useAppSelector(selectIsInFrame)

  useEffect(() => {
    dispatch(fetchExams())
      .unwrap()
      .then(() => {
        window.parent.postMessage({ frameHeight: document.body.scrollHeight }, '*')
      })
    dispatch(resetExam())
  }, [])

  useDocumentTitle('Interview Questions')

  return (
    <div className={style.box}>
      {status === 'loading' ? (
        <Loader />
      ) : (
        <>
          {!isInFrame && <Banner />}
          <h1 className={style.title}>Выбери тему</h1>
          <FilterPanel className={style['filter-panel']} />
          <CardsList />
        </>
      )}
    </div>
  )
}
